module.exports = __webpack_public_path__ + "static/img/poster-bac4.11a86586.png";